module.exports = __webpack_public_path__ + "img/178.1ae9b22a.jpg";